<template>
  <div class="nineteen-ninety_nine-root">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>
    <div class="act-nine-con">
      <div class="bg-block" style="padding-top: 84px; margin-top: -84px">
        <img v-if="$i18n.locale === 'es'" class="act-nine-tit" src="./images/bg-tit3.webp" alt="" />
        <img v-else-if="$i18n.locale === 'pt'" class="act-nine-tit" src="./images/bg-tit2.webp" alt="" />
        <img v-else class="act-nine-tit" src="./images/bg-tit1.webp" alt="" />
        <div class="time-tips">
          <img class="time-icon" src="./images/clock.webp" alt="" />
          <div class="tips-text">
            <span>{{ $t('lang.NineteenDotNinetyNine.k001') }}</span>
            <span>{{ actData.deadLine }}</span>
          </div>
        </div>

        <div class="act-nine-rules act-nine-rules1">
          <div class="rules-left">
            <img src="./images/coins-2.webp" alt="" />
            <p>
              <span>{{ actData.originAmount }}</span>
              <span v-if="actData.discountDesc">+{{ actData.discountDesc }}</span>
            </p>
            <div>{{ actData.currency }}{{ handleDiv100(actData.originPrice) }}</div>
          </div>
          <div class="rules-center">
            <i>+</i>
          </div>
          <div class="rules-right">
            <img src="./images/coins-1.webp" alt="" />
            <p>{{ actData.extraAmount }}</p>
            <p>{{ $t('lang.CommonModule.k010') }}</p>
            <img src="./images/discount.webp" alt="" />
          </div>
        </div>
        <img class="rules-arrow" src="./images/arrow-down.webp" alt="" />
        <div class="act-nine-rules act-nine-rules2">
          <div class="rules-content">
            <div>
              <img src="./images/coins-3.webp" alt="" />
              <p>
                <span>{{ actData.targetAmount }}</span>
                <span v-if="actData.discountDesc">+{{ actData.discountDesc }}</span>
              </p>
            </div>
            <div>{{ actData.currency }}{{ handleDiv100(actData.originPrice) }}</div>
            <div class="coins-total">{{ $t('lang.CommonModule.k029') }}</div>
          </div>
        </div>
        <div v-if="apiData" class="top-up-btn" @click.self="handleTopUp">{{ $t('lang.NineteenDotNinetyNine.k005') }}</div>
        <ul class="act-tips">
          <li>{{ $t('lang.NineteenDotNinetyNine.k002') }}</li>
          <li>1.{{ $t('lang.NineteenDotNinetyNine.k006') }}</li>
          <li>2.{{ $t('lang.NineteenDotNinetyNine.k003') }}</li>
          <li>3.{{ $t('lang.NineteenDotNinetyNine.k004') }}</li>
        </ul>
      </div>
      <div style="height: 30px"></div>
    </div>
  </div>
</template>

<script>
import { apiNineteenDotNinetyNineAct } from './apidir/api.js'
import { compareVersion } from '@/utils/common.js'

import Decimal from 'decimal.js'

export default {
  data() {
    return {
      appInfo: null,
      gid: '',
      productId: '',
      apiData: null,
      actData: {
        originAmount: 0,
        originPrice: 0,
        extraAmount: 0,
        targetAmount: 0,
        targetPrice: 0,
        currency: '',
        discountDesc: '',
        deadLine: '0d 0h',
      },
    }
  },
  methods: {
    getActInfo() {
      apiNineteenDotNinetyNineAct().then((resData) => {
        if (resData && !resData.error) {
          try {
            this.apiData = resData
            this.gid = resData.gid || ''
            this.productId = resData.productId || ''

            this.actData.currency = resData.currency || ''
            this.actData.discountDesc = resData.discountDesc || ''

            this.actData.originAmount = resData.amount || 0
            this.actData.originPrice = resData.price || 0

            if (resData.presentPropList && resData.presentPropList.length) {
              this.actData.extraAmount = resData.presentPropList[0].number
            }

            this.actData.targetAmount = Decimal(this.actData.originAmount).plus(Decimal(this.actData.extraAmount))
            this.actData.targetPrice = resData.price || 0

            this.actData.deadLine = this.transformSeconds2(resData.expireSeconds) || '0d 0h'
          } catch (err) {
            console.log('try catch', err)
          }
        }
      })
    },
    // 去pay页面支付
    handleTopUp() {
      // 支付基础参数
      const payQuery = {
        scene: 'activity',
        activityType: 3,
        gid: this.gid,
        productId: this.productId,
        amount: this.actData.targetAmount,
        backType: 'previous',
      }

      // price currency参数控制 原生支付的显示
      // 下面这些版本之后，payGoogleFromWeb 才支持服务端需要回传的avtivityType
      // vava
      let appChannel = ''
      try {
        appChannel = this.getChannel()
        if (appChannel === 'vvg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '4.2.1')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.actData.targetPrice)
            payQuery.currency = this.actData.currency
          }
        }
        // joychat
        if (appChannel === 'jcg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '2.3.0')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.actData.targetPrice)
            payQuery.currency = this.actData.currency
          }
        }
        // echo
        if (appChannel === 'eca') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '1.2.1')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.actData.targetPrice)
            payQuery.currency = this.actData.currency
          }
        }
        if (appChannel === 'ecg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '1.3.0')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.actData.targetPrice)
            payQuery.currency = this.actData.currency
          }
        }
        // kiko
        if (appChannel === 'kkg') {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.actData.targetPrice)
          payQuery.currency = this.actData.currency
        }
      } catch (err) {
        console.error(err)
      }

      // echo 支付页面
      if (appChannel === 'eca' || appChannel === 'ecg') {
        this.$router.push({
          path: '/echo-pay',
          query: payQuery,
        })
        return
      }

      // 其他 支付页面
      this.$router.push({
        path: '/pay',
        query: payQuery,
      })
    },
  },
  created() {
    this.appInfo = this.$client.getAppInfo() || { version: '' }
    this.getActInfo()
  },
}
</script>

<style lang="less" scoped>
// 顶部导航
.nineteen-ninety_nine-root {
  .custom-nav-block {
    background-color: transparent;
  }
}

.nineteen-ninety_nine-root {
  width: 100%;
  height: 100vh;
  background-image: url(./images/bg-1.webp);
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: 0 0;
  display: flex;
  flex-direction: column;

  .act-nine-con {
    flex: 1;
    overflow-y: scroll;
    .bg-block {
      background-image: url(./images/bg-1.webp);
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: 0 0;

      .act-nine-tit {
        width: 100%;
        height: 120px;
      }

      .time-tips {
        width: calc(100% - 42px);
        height: 31px;
        margin-left: 40px;
        background: url(./images/bg-2.webp) center / 100% no-repeat;
        position: relative;
        overflow: visible;
        .time-icon {
          position: absolute;
          left: -20px;
          top: -5px;
        }
        .tips-text {
          padding-left: 24px;
          span:nth-child(1) {
            width: 126px;
            height: 17px;
            font-family: 'ArialNarrow', 'ArialNarrow';
            font-weight: normal;
            font-size: 15px;
            color: #ffffff;
            text-align: right;
            font-style: italic;
            vertical-align: middle;
          }
          span:nth-child(2) {
            width: 52px;
            height: 23px;
            font-family: 'ArialNarrow', 'ArialNarrow';
            font-weight: normal;
            font-size: 20px;
            color: #fff600;
            text-align: left;
            font-style: italic;
            padding: 0 4px;
            vertical-align: middle;
          }
        }
      }

      .act-nine-rules {
        width: 343px;
        margin: 0 auto;
        padding: 12px;
      }

      .act-nine-rules1 {
        background: #7ac07f;
        border-radius: 16px;
        display: flex;
        margin-top: 24px;

        .rules-left,
        .rules-right {
          width: 140px;
          background: #feffff;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
          border-radius: 12px;
          border: 1px solid #15a624;
        }
        .rules-left {
          img {
            height: 60px;
          }
          p {
            display: flex;
            align-items: center;
            justify-content: center;
            span:nth-child(1) {
              font-family: 'Roboto-Regular';
              font-weight: 600;
              font-size: 24px;
              color: #366c61;
              line-height: 28px;
              text-align: right;
              font-style: normal;
            }
            span:nth-child(2) {
              font-family: 'Roboto-Regular';
              font-weight: 500;
              font-size: 11px;
              color: #ffa916;
              line-height: 11px;
              text-align: right;
              font-style: normal;
              margin-left: 6px;
            }
          }
          div {
            margin-top: 4px;
            line-height: 30px;
            background: #fcffcc;
            border-radius: 0px 0px 11px 11px;

            font-family: 'Inter-Regular';
            font-weight: 600;
            font-size: 17px;
            color: #007529;
            text-align: center;
          }
        }
        .rules-right {
          position: relative;
          img {
            height: 60px;
          }
          p:nth-child(2) {
            font-family: 'Roboto-Regular';
            font-weight: 600;
            font-size: 24px;
            color: #366c61;
            line-height: 28px;
            text-align: center;
          }
          p:nth-child(3) {
            font-family: 'Roboto-Regular';
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            text-align: center;
          }
          img:nth-child(4) {
            width: 48px;
            height: 48px;
            position: absolute;
            top: -10px;
            right: -10px;
          }
        }
        .rules-center {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            margin-top: 5px;
            width: 21px;
            height: 36px;
            font-family: 'Inter-Regular';
            font-weight: 800;
            font-size: 30px;
            color: #ffffff;
            line-height: 36px;
            font-style: normal;
            text-align: center;
            -webkit-text-stroke: 1px #15a624;
          }
        }
      }

      .rules-arrow {
        width: 36px;
        height: 48px;
        display: block;
        margin: -12px auto 0;
      }

      .act-nine-rules2 {
        background: #7ac07f;
        border-radius: 16px;
        display: flex;

        .rules-content {
          width: 319px;
          background: #feffff;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
          border-radius: 12px;
          border: 1px solid #15a624;
          position: relative;
          div:nth-child(1) {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 0;
            img {
              width: 60px;
              height: 60px;
            }
            p {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 20px;
              span:nth-child(1) {
                font-family: 'Roboto-Regular';
                font-weight: 600;
                font-size: 30px;
                color: #366c61;
                line-height: 28px;
                text-align: right;
                font-style: normal;
              }
              span:nth-child(2) {
                font-family: 'Roboto-Regular';
                font-weight: 500;
                font-size: 20px;
                color: #ffa916;
                line-height: 11px;
                text-align: right;
                font-style: normal;
                margin-left: 6px;
              }
            }
          }
          div:nth-child(2) {
            line-height: 30px;
            background: #fcffcc;
            border-radius: 0px 0px 11px 11px;

            font-family: 'Inter-Regular';
            font-weight: 600;
            font-size: 17px;
            color: #007529;
            text-align: center;
          }
          .coins-total {
            position: absolute;
            top: 0;
            left: 0;
            display: inline-block;
            height: 24px;
            background: #014924;
            border-radius: 12px 0px 12px 0px;
            padding: 3px 12px;
            font-family: 'Inter-Regular';
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }

      .top-up-btn {
        width: 263px;
        line-height: 40px;
        margin: 40px auto 0;
        background: #014924;
        border-radius: 20px;

        font-family: 'Roboto-Regular';
        font-weight: normal;
        font-size: 20px;
        color: #ffffff;
        text-align: center;
        font-style: normal;

        &:active {
          background: #008842;
        }
      }

      .act-tips {
        margin-top: 30px;
        font-family: 'Roboto-Regular';
        font-weight: 400;
        color: #21ae78;
        padding: 0 24px;
        li {
          font-size: 12px;
          margin-bottom: 8px;
        }
        li:nth-child(1) {
          font-size: 17px;
          margin-bottom: 12px;
        }
      }
    }
  }
}
</style>
